import * as THREE from 'three';
import { heroModel } from '../entities/models';

const W = 192;
const H = 256;
const cache = new Map<string, string>();

export function heroPortrait(renderer: THREE.WebGLRenderer, robe: string, trim: string): string {
  const key = `${robe}|${trim}`;
  const hit = cache.get(key);
  if (hit) return hit;

  let target: THREE.WebGLRenderTarget | null = null;
  let body: THREE.Mesh | null = null;
  let orb: THREE.Mesh | null = null;
  const prevTarget = renderer.getRenderTarget();
  const prevColor = renderer.getClearColor(new THREE.Color());
  const prevAlpha = renderer.getClearAlpha();
  const prevAutoClear = renderer.autoClear;
  try {
    target = new THREE.WebGLRenderTarget(W, H, { depthBuffer: true });
    target.texture.colorSpace = THREE.SRGBColorSpace;

    const scene = new THREE.Scene();
    const model = heroModel(robe, trim);
    body = model.body;
    orb = model.orb;
    body.castShadow = false;
    const group = new THREE.Group();
    group.add(body, orb);
    group.rotation.y = -0.26;
    scene.add(group);

    const hemi = new THREE.HemisphereLight('#dfd4ff', '#281c42', 1.45);
    const keyLight = new THREE.DirectionalLight('#fff5dc', 2.2);
    keyLight.position.set(2.6, 4.4, 4.2);
    const rimLight = new THREE.DirectionalLight(trim, 1.1);
    rimLight.position.set(-2.8, 2.4, -2.5);
    scene.add(hemi, keyLight, rimLight);

    const camera = new THREE.PerspectiveCamera(32, W / H, 0.5, 20);
    camera.position.set(0.12, 1.5, 5.1);
    camera.lookAt(0.08, 1.3, 0);

    renderer.setRenderTarget(target);
    renderer.setClearColor(0x000000, 0);
    renderer.clear(true, true, false);
    renderer.render(scene, camera);

    const raw = new Uint8Array(W * H * 4);
    renderer.readRenderTargetPixels(target, 0, 0, W, H, raw);

    const canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    const img = ctx.createImageData(W, H);
    const rowBytes = W * 4;
    for (let y = 0; y < H; y += 1) {
      const srcOff = (H - 1 - y) * rowBytes;
      img.data.set(raw.subarray(srcOff, srcOff + rowBytes), y * rowBytes);
    }
    ctx.putImageData(img, 0, 0);
    const url = canvas.toDataURL('image/png');
    if (!url.startsWith('data:image/png')) return '';
    cache.set(key, url);
    return url;
  } catch {
    return '';
  } finally {
    renderer.setRenderTarget(prevTarget);
    renderer.setClearColor(prevColor, prevAlpha);
    renderer.autoClear = prevAutoClear;
    body?.geometry.dispose();
    (body?.material as THREE.Material | undefined)?.dispose();
    orb?.geometry.dispose();
    (orb?.material as THREE.Material | undefined)?.dispose();
    target?.dispose();
  }
}
